export default __webpack_public_path__ + "static/media/Courtesan_Katsushika_Hokusai_30_x_40.2a7fa4c0.jpg";